import { getType } from 'typesafe-actions'

import { ConfigActions } from './actions'
import { ConfigLoadingState, ConfigState, PrimaryIdentifier, PricesMode } from './types'

const initialState: ConfigState = {
  status: ConfigLoadingState.NotLoaded,
  countryCode: '',
  pageSizes: {},
  localeMap: {},
  registrationNumbers: {},
  publicUrl: '',
  completedReportStatus: 'Delivered',
  googleRecaptchaSiteKey: '',
  viewHtmlIcon: true,
  officialDocumentsCountries: [],
  gtmId: '',
  apiBlocked: false,
  pricesMode: PricesMode.OnlyGross,
  primaryIdentifier: PrimaryIdentifier.Report,
  domesticOfferingCountries: [],
  domesticOfferingFallbackCountry: 'VN',
  redirectToCartOnItemAdded: false,
  orderProcessingTimeoutSec: 30,
  officeEnabled: false,
  import: {},
  maximumNumberOfSupportedItems: 100,
  localCountries: [],
  showAiChatbotButton: false,
  showAIColumsOnArchive: false,
  showAvailableBalance: true
}

export const reducer = (state: ConfigState = initialState, action: ConfigActions): ConfigState => {
  switch (action.type) {
    case getType(ConfigActions.setJsonConfig): {
      const { config } = action.payload
      return {
        ...state,
        countryCode: config.countryCode,
        pageSizes: config.pageSizes,
        localeMap: config.localeMap,
        registrationNumbers: config.registrationNumbers,
        publicUrl: config.publicUrl,
        completedReportStatus: config.completedReportStatus || state.completedReportStatus,
        googleRecaptchaSiteKey: config.googleRecaptchaSiteKey,
        viewHtmlIcon: config.viewHtmlIcon,
        officialDocumentsCountries: config.officialDocumentsCountries,
        gtmId: config.gtmId,
        pricesMode: config.pricesMode,
        primaryIdentifier: config.primaryIdentifier || PrimaryIdentifier.Report,
        domesticOfferingCountries: config.domesticOfferingCountries,
        redirectToCartOnItemAdded: config.redirectToCartOnItemAdded,
        orderProcessingTimeoutSec: config.orderProcessingTimeoutSec,
        officeEnabled: config.officeEnabled,
        import: config.import ? config.import : state.import,
        maximumNumberOfSupportedItems: config.maximumNumberOfSupportedItems,
        localCountries: config.localCountries
      }
    }
    case getType(ConfigActions.setContentConfiguration): {
      return {
        ...state,
        content: action.payload.contentConfig
      }
    }
    case getType(ConfigActions.setConfigLoadingState): {
      const loadedLanguage =
        action.payload.state === ConfigLoadingState.Loaded ? action.payload.loadedLanguage : state.loadedLanguage
      return {
        ...state,
        status: action.payload.state,
        loadedLanguage
      }
    }
    case getType(ConfigActions.setApiBlocked): {
      return {
        ...state,
        apiBlocked: action.payload
      }
    }
    default:
      return state
  }
}
